














































import Vue from 'vue';
import { DocumentHeader, DocumentParagraph } from '@/utils/types/documentRepo/documentComponent';
import { Readability, SentenceDTO } from '@/utils/types/common';
import format from '@/utils/format';
import functions from '@/utils/functions';

const { ifPresent } = functions;

export default Vue.extend({
  name: 'DocumentParagraphView',
  props: {
    millis: Number,
    hash: String,
    documentParagraph: Object as () => DocumentParagraph,
  },
  computed: {
    readability(): Readability {
      return this.documentParagraph.readability;
    },
    sentences(): SentenceDTO[] {
      return this.documentParagraph.sentences;
    },
    headers(): DocumentHeader[] {
      return [...this.documentParagraph.parents].reverse();
    },
  },
  methods: {
    buildHeader(h: DocumentHeader): string {
      return `${h.level > 0 ? `${'\t'.repeat(h.level - 1)}└─` : ''}${h.title}`;
    },
    formatRevision: format.formatRevision,
  },
  filters: {
    formatScore: ifPresent(format.formatReadabilityScore),
  },
});
